import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Light"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M11.25 1.5H12.75V5.22H11.25V1.5ZM16.2654 6.66749L18.8956 4.03799L19.9561 5.09849L17.3259 7.72874L16.2654 6.66749ZM18.78 11.25H22.5V12.75H18.78V11.25ZM16.2697 17.328L17.3302 16.2675L19.9604 18.8978L18.8999 19.9575L16.2697 17.328ZM11.25 18.78H12.75V22.5H11.25V18.78ZM4.04688 18.9015L6.67788 16.2713L7.73838 17.3318L5.10813 19.962L4.04688 18.9015ZM1.5 11.25H5.22V12.75H1.5V11.25ZM4.04259 5.10224L5.10384 4.04174L7.73409 6.67199L6.67359 7.73249L4.04259 5.10224ZM12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9ZM12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Light.vue"]]);
